export default __webpack_public_path__ + "static/media/sandero-medium2.e0b8921f.jpg";